export class WorkSpaceUserRoles {
  private readonly _roles: string[];
  private readonly _roleNames: string[];

  constructor(props: { roles: string[]; roleNames: string[] }) {
    this._roles = props.roles;
    this._roleNames = props.roleNames;
  }

  get roles(): string[] {
    return this._roles;
  }

  get roleNames(): string[] {
    return this._roleNames;
  }
}
